import React from 'react';
import { getGlobalStyles } from 'styles';
import { translate } from 'localizations';
import { useAppSelector } from 'hooks/redux';
import { CallInfoType, CallTagType } from 'store/calls/calls.types';
import { useDispatch, useSelector } from 'react-redux';
import { callsActions } from 'store/calls';
import { RootState } from 'store/store';
import { ISearchedWord } from '../TagsBlock/TagsBlock';
import { getFormattedTags } from '../../CallBody/utils';
import { callFragmentsLimit } from '../../constants';

interface IOwnProps {
	expanded: boolean;
	tagsAndFragmentsArray: {
		tags: any[];
		fragments: any[];
		searchedWords?: ISearchedWord[];
	};
	setCurrentFragmentHandle: (value: CallTagType | ISearchedWord) => void;
	callInfo: CallInfoType | null;
}

const CallsFragments: React.FC<IOwnProps> = ({
	tagsAndFragmentsArray,
	expanded,
	setCurrentFragmentHandle,
	callInfo,
}) => {
	const dispatch = useDispatch();
	const { setFragmentExpanded } = callsActions;
	const { blueTag, purpleTag, grayTag } = getGlobalStyles();
	const { language } = useAppSelector((state) => state.lang);
	const { trimmedTags, reducedTags } = getFormattedTags(tagsAndFragmentsArray.fragments, callFragmentsLimit);

	const expandedFragments = useSelector((state: RootState) => state.calls.expandedFragments);
	const callId = callInfo?.id;
	const showAllTags = callId ? expandedFragments?.[callId] || false : false;

	const tagsToDisplay = showAllTags ? tagsAndFragmentsArray.fragments : trimmedTags;

	const handleShowMoreTags = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		if (callId) {
			dispatch(setFragmentExpanded({ callId, isExpanded: !showAllTags }));
		}
	};

	return (
		<div style={{ display: 'flex', marginBottom: '5px' }}>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					flexWrap: 'wrap',
					width: '100%',
				}}
			>
				{(tagsAndFragmentsArray.searchedWords || []).map((word: ISearchedWord) => (
					<div
						key={word.fragment}
						className={blueTag}
						onClick={async (e) => {
							setCurrentFragmentHandle(word);
							if (expanded) {
								e.stopPropagation();
							}
						}}
					>
						{word.text}
					</div>
				))}
				{(tagsToDisplay || []).map((fragment: { tag: CallTagType; count: number }) => (
					<div
						key={fragment.tag.name}
						className={purpleTag}
						onClick={async (e) => {
							setCurrentFragmentHandle(fragment.tag);
							if (expanded) {
								e.stopPropagation();
							}
						}}
					>
						{fragment.tag.name} {fragment.count > 1 && <>x{fragment.count}</>}
					</div>
				))}
				{reducedTags.length > 0 && (
					<button className={grayTag} onClick={handleShowMoreTags}>
						{showAllTags
							? translate('tagHide', language)
							: `${translate('show_more', language)} ${reducedTags.length}`}
					</button>
				)}
			</div>
		</div>
	);
};

export default CallsFragments;
